module.exports = __webpack_public_path__ + "img/trophy2.e1813768.svg";